export default __webpack_public_path__ + "static/media/sadhana.ef573c33.png";